import axios from "axios";
import {Workflow, WorkflowExecution} from "@/types/workflow";


export interface CreateWorkflowRequest {
    name: string;
    steps: any[];
    isDefault?: boolean;
}

export interface UpdateWorkflowRequest extends CreateWorkflowRequest {}

export async function getWorkflows(): Promise<Workflow[]> {
    let workflows: unknown;

    try {
        const response = await axios.get(route('workflows.list'));
        workflows = response.data?.data;
    } catch (error: any) {
        const message = error.response?.data?.message || 'Failed to fetch workflows';
        throw new Error(message);
    }

    if (!Array.isArray(workflows)) {
        throw new Error('Unexpected response while fetching workflows');
    }

    return workflows;
}

export async function getWorkflowExecution(
    workflowId: number,
): Promise<WorkflowExecution> {
    try {
        const response = await axios.get(route('workflow-executions.show', workflowId));
        return response.data;
    } catch (error: any) {
        const message = error.response?.data?.message || 'Failed to fetch workflow execution details';
        throw new Error(message);
    }
}

export async function createWorkflow(data: CreateWorkflowRequest): Promise<Workflow> {
    try {
        const response = await axios.post(route('workflows.store'), data);
        return response.data.data;
    } catch (error: any) {
        const message = error.response?.data?.message || 'Failed to create workflow';
        throw new Error(message);
    }
}

export async function updateWorkflow(id: number, data: UpdateWorkflowRequest): Promise<Workflow> {
    try {
        const response = await axios.put(route('workflows.update', id), data);
        return response.data.data;
    } catch (error: any) {
        const message = error.response?.data?.message || 'Failed to update workflow';
        throw new Error(message);
    }
}

export async function createOrUpdateWorkflow(workflow: Workflow): Promise<Workflow> {
    if (workflow.id && workflow.id > 0) {
        return updateWorkflow(workflow.id, workflow);
    } else {
        return createWorkflow(workflow);
    }
}

export async function deleteWorkflow(id: number): Promise<void> {
    try {
        await axios.delete(route('workflows.destroy', id));
    } catch (error: any) {
        const message = error.response?.data?.message || 'Failed to delete workflow';
        throw new Error(message);
    }
}
